import ShiftCostInfo from './ShiftCostInfo';

export default ShiftCostInfo;
